<template>
  <ul class="workpackage-list">
    <li
      v-for="workpackage in list"
      v-show="show(workpackage)"
      :id="`wp-list-element-${workpackage._id}`"
      :key="workpackage._id"
      class="workpackage-list__element"
    >
      <WorkpackageWrapper
        :id="`wp-panel-wrapper-${workpackage._id}`"
        :entity="entity"
        :is-link="isLink"
        :workpackage="workpackage"
      />
    </li>
  </ul>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { get } from 'lodash';

import { useWorkpackagesStore } from '@/stores/workpackages';
import { useToolDataStore } from '@/stores/tool-data';
import { useDomUtility } from '@/composables/dom-utils';

export default {
  props: {
    workpackages: {
      type: Array,
      required: true,
    },

    visibleWorkpackages: {
      type: Array,
      required: false,
      default: () => [],
    },

    entity: {
      type: String,
      required: false,
      default: '',
    },

    isLink: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup() {
    const { scrollToElement } = useDomUtility();

    return { scrollToElement };
  },

  data() {
    return { list: this.workpackages };
  },

  computed: { ...mapState(useWorkpackagesStore, ['selectedWorkpackage']) },

  watch: {
    workpackages: {
      deep: true,
      handler() {
        this.list = this.workpackages;
      },
    },
  },

  created() {
    this.fetchSnapshotDates();
    if (this.hasPeriodIdsEnabled) {
      this.getPeriodIds();
    }
  },

  mounted() {
    const workpackageId = get(this.selectedWorkpackage, '_id');

    if (workpackageId) this.scrollToElement(`wp-panel-${workpackageId}`);
  },

  methods: {
    ...mapActions(useWorkpackagesStore, ['fetchSnapshotDates']),
    ...mapActions(useToolDataStore, ['getPeriodIds']),

    show(workpackage) {
      if (get(workpackage, 'archived') === true) return true;
      return this.visibleWorkpackages.includes(workpackage._id);
    },
  },
};
</script>

<style lang="scss" scoped>
.workpackage-list {
  list-style-type: none;
  padding: 0;
  min-width: 1350px;

  &__element {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  &__element:first-child {
    margin-top: 0;
  }

  &__element:last-child {
    margin-bottom: 0;
  }

  .no-data-text {
    width: 29rem;
    font-size: 1.2rem;
    padding: 1rem 0;
    white-space: normal;
  }
}
</style>
